var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Loading from '../Loading';
import Webcam from 'react-webcam';
import PoseChallenge from './pose/index';
import { useSelector } from 'react-redux';
import Service from '../../services/Service';
import TopNavigation from '../TopNavigation';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from '../../i18n';
import { Container, CameraContainer, SelfieMarginContainer, SelfieMargin, StartChallengeButton, ChallengeContainer } from './styles';
;
;
var width = Math.round(window.innerWidth * 0.95);
var height = Math.round(width / 0.75);
var marginStyle = {
    width: window.innerWidth / 1.5,
    height: window.innerWidth,
};
var videoConstraints = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    facingMode: 'user',
};
var StepLivenessReact = function (_a) {
    var step = _a.step;
    var _b = useSelector(function (state) { return state.form; }), form = _b.form, formInfo = _b.formInfo;
    var t = useTranslation().t;
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(null), pose = _d[0], setPose = _d[1];
    var _e = React.useState(), challengeType = _e[0], setChallengeType = _e[1];
    var webcamRef = React.useRef(null);
    var capture = function () {
        var _a, _b;
        if (webcamRef && webcamRef.current) {
            var imageSrc = webcamRef.current.getScreenshot();
            (_b = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.pause();
            return imageSrc;
        }
        ;
        return null;
    };
    var verifyUser = function () {
        setLoading(true);
        var imageSrc = capture();
        if (imageSrc) {
            var image_1 = new Image();
            image_1.src = imageSrc;
            image_1.onload = function () {
                var newForm = __assign({}, form);
                var params = {
                    tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
                    step: newForm.steps[step].step,
                    field: "challenge_type_liveness",
                    value: JSON.stringify({
                        imageWidth: image_1.naturalWidth,
                        imageHeight: image_1.naturalHeight,
                        frame: imageSrc
                    })
                };
                Service.serviceField(params)
                    .then(function (response) {
                    var _a, _b;
                    if (response) {
                        var challengeType_1 = response[0].value;
                        if (challengeType_1) {
                            setChallengeType(challengeType_1);
                            if (challengeType_1 === "POSE") {
                                var eyePose = (_a = response.find(function (r) { return r.field === "pose_eyes_liveness"; })) === null || _a === void 0 ? void 0 : _a.value;
                                var mouthPose = (_b = response.find(function (r) { return r.field === "pose_mouth_liveness"; })) === null || _b === void 0 ? void 0 : _b.value;
                                if (eyePose && mouthPose) {
                                    setPose({ mouthPose: mouthPose, eyePose: eyePose });
                                }
                            }
                            if (challengeType_1 === "NOSE") {
                                // TODO
                            }
                        }
                    }
                    setLoading(false);
                })
                    .catch(function () {
                    var _a, _b;
                    setLoading(false);
                    (_b = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.play();
                });
            };
        }
    };
    return (React.createElement(Container, null,
        React.createElement(ToastContainer, null),
        React.createElement(TopNavigation, { title: form.steps[step].showStepName ? form.steps[step].stepName : '', showBackButton: form.steps[step].goBack, showLogo: true, headerTransparent: form.steps[step].headerTransparent }),
        challengeType ? (React.createElement(ChallengeContainer, null,
            (challengeType === "POSE" && pose) && (React.createElement(PoseChallenge, { step: step, cameraWidth: width, cameraHeight: height, eyePose: pose.eyePose, mouthPose: pose.mouthPose, videoConstraints: videoConstraints })),
            challengeType === "NOSE" && null)) : (React.createElement(CameraContainer, null,
            React.createElement(Webcam, { mirrored: true, audio: false, width: width, height: height, ref: webcamRef, screenshotQuality: 0.98, forceScreenshotSourceSize: true, screenshotFormat: "image/jpeg", videoConstraints: videoConstraints, style: { objectFit: "cover", height: height, width: width } }),
            React.createElement(SelfieMarginContainer, null,
                React.createElement(SelfieMargin, { style: marginStyle })),
            React.createElement(StartChallengeButton, { text: t('liveness.startChallenge'), onClick: verifyUser, disabled: loading }),
            loading && (React.createElement(Loading, { type: "bubbles" }))))));
};
export default StepLivenessReact;
